import { forwardRef } from 'react'
import { BaseInput, InputSize } from '../base'
import type { TextInputProps } from './types'

export { InputVariant } from '../base'

const TextInput = forwardRef<HTMLInputElement, TextInputProps>((props, ref) => {
    return <BaseInput {...props} ref={ref} size={InputSize.medium} className={'text-input'} />
  }
)
TextInput.displayName = 'TextInput'
export default TextInput
